/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/naming-convention */
import { captureMessage } from '@sentry/browser';
import { getCompany } from '../company/actions';
import { FetchError, fetchGet, fetchPost } from '../fetch';
import { setLanguage } from '../language/actions';

export const AUTHENTICATION_LOGGING_IN = 'AUTHENTICATION_LOGGING_IN';
export const AUTHENTICATION_LOGGED_IN = 'AUTHENTICATION_LOGGED_IN';
export const AUTHENTICATION_LOGOUT = 'AUTHENTICATION_LOGOUT';
export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';

export function login(emailAddress: string, password: string, otpToken?: string, company?: string) {
    return async (dispatch: any) => {
        if (!emailAddress || !password) {
            return;
        }
        await dispatch(loggingIn());
        try {
            const response = await fetchPost('/api/session', undefined, { emailAddress, password, otpToken, company });
            const json = response.json;

            sessionStorage.setItem('zxy-token', json.token);
            await dispatch(receiveLogin(json));
        } catch (error) {
            let code = 'DEFAULT';
            let restrictedHostName: string | undefined = undefined;
            let companies: Array<{ id: string; name: string }> | undefined = undefined;
            if (error instanceof FetchError) {
                if (error.statusCode >= 400) {
                    if (error.errorCode) {
                        code = error.errorCode;
                    }
                }
                if (error.responseData) {
                    restrictedHostName = error.responseData.restrictedHostName;
                    companies = error.responseData.companies;
                }
            }
            await dispatch(loginFailed(code, restrictedHostName, companies));
        }
    };
}

export function tempLogin(signature: string, surveyId: string) {
    return async (dispatch: any) => {
        await dispatch(loggingIn());
        try {
            const response = await fetchPost('/api/tempsession', undefined, { signature, surveyId });

            const json = response.json;
            sessionStorage.setItem('zxy-token', json.token);
            await dispatch(receiveLogin(json));
        } catch (error) {
            let code = 'DEFAULT';
            if (error instanceof FetchError) {
                if (error.statusCode >= 400) {
                    if (error.errorCode) {
                        code = error.errorCode;
                    }
                }
            }
            await dispatch(loginFailed(code));
        }
    };
}

export function logout() {
    return (dispatch: any) => {
        sessionStorage.removeItem('zxy-token');
        dispatch({ type: AUTHENTICATION_LOGOUT });
    };
}

function loginFailed(code: string, restrictedHostName?: string, companies?: Array<{ id: string; name: string }>) {
    return { type: AUTHENTICATION_FAILED, code, restrictedHostName, companies };
}

function loggingIn() {
    return { type: AUTHENTICATION_LOGGING_IN };
}

export function receiveLogin(json: any) {
    return async (dispatch: any) => {
        await dispatch({
            type: AUTHENTICATION_LOGGED_IN,
            user: json,
        });

        if (json.language) {
            await dispatch(setLanguage(json.language));
        }
        await dispatch(getCompany());
    };
}

export function check(shouldForceSso: boolean) {
    return async (dispatch: any) => {
        try {
            const response = await fetchGet('/api/session');
            const json = response.json;
            sessionStorage.setItem('zxy-token', json.token);
            await dispatch(receiveLogin(json));
        } catch (error) {
            if (error instanceof FetchError) {
                if (error.statusCode >= 400) {
                    if (shouldForceSso) {
                        // TODO: ZXY-1209 clean up if bug is fixed
                        if (!window?.location?.href) {
                            captureMessage('window.location.href is undefined');
                        }
                        window.location.href = '/sso/login';
                    }
                }
            }
            console.log(error);
        }
    };
}

export function loginAs(userId: string, companyId: string) {
    return async (dispatch: any) => {
        await dispatch(loggingIn());
        try {
            const response = await fetchPost('/api/sessionSwitch', undefined, { userId, companyId });

            const json = response.json;

            sessionStorage.setItem('zxy-token', json.token);
            await dispatch(receiveLogin(json));
        } catch (error) {
            let code = 'DEFAULT';
            if (error instanceof FetchError) {
                if (error.statusCode >= 400) {
                    if (error.errorCode) {
                        code = error.errorCode;
                    }
                }
            }
            await dispatch(loginFailed(code));
        }
    };
}
